import Input from 'src/components/Input/Input';
import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';

export const ProjectDescriptionField = ({
  field,
  data = '',
  control,
  readonly,
  setValue,
  compact,
}) => {
  useEffect(() => {
    if (readonly && data) {
      setValue(field.key, data);
      return;
    }

    if (readonly) {
      setValue(field.key, '');
    }
  }, [readonly, field, data]);

  return field ? (
    <Controller
      control={control}
      name={field.key}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className={'flex flex-col w-full'}>
          <Input
            className={'!py-2.5'}
            readonly={readonly}
            label={'Company description'}
            type={'text'}
            placeholder={'A fintech startup making payments effortless'}
            invalidMessage={error?.message}
            value={value || ''}
            isValid={!error?.message}
            onChange={onChange}
          />
        </div>
      )}
    />
  ) : null;
};
